"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionWithHeader = void 0;
const react_1 = __importDefault(require("react"));
const btn_link_1 = require("./btn-link");
const btn_link_button_1 = require("./btn-link-button");
const styled_1 = require("./styled");
const __1 = require("..");
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../helpers");
const SectionWithHeader = props => {
    const { title, btnLabel, btnAction, buttonType, showButton = true, children, iconLabel } = props;
    return (react_1.default.createElement(styled_1.StyledSectionWrapper, { className: "section-with-header-wrapper" },
        react_1.default.createElement(styled_1.StyledHeaderContainer, { className: "header-container" },
            react_1.default.createElement(__1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, tag: components_core_1.TextTag.h2, style: {
                    [helpers_1.Breakpoints.default]: {
                        fontSize: __1.TextSize.TextSize24,
                        fontWeight: __1.TextWeight.bold
                    },
                    [helpers_1.Breakpoints.b1280]: {
                        fontSize: __1.TextSize.TextSize32,
                        lineHeight: __1.TextLineHeight.TextLineHeight44
                    }
                } }, title),
            showButton && buttonType === 'link' ? (react_1.default.createElement(styled_1.StyledCursorAction, { className: "cursor-action" },
                react_1.default.createElement(btn_link_1.BtnLink, { btnAction: btnAction, btnLabel: btnLabel, iconLabel: iconLabel }))) : showButton && buttonType === 'button' ? (react_1.default.createElement(btn_link_button_1.BtnLinkButton, { btnAction: btnAction, btnLabel: btnLabel, iconLabel: iconLabel })) : null),
        children));
};
exports.SectionWithHeader = SectionWithHeader;
